import PropTypes from 'prop-types'
import { memo } from 'react'

import { APP_HREF } from '../../../config'
import { ERROR_TYPES, getErrorByType } from '../config'

import * as S from './styles'

export const BlocErrorMain = memo(({ flag, onClickButton, ...props }) => {
  const { illustration, message } = getErrorByType(flag)

  return (
    <S.Card {...props}>
      <S.IllustrationContainer>
        <S.Illustration $name={illustration} />
      </S.IllustrationContainer>

      {message}

      <S.Button href={APP_HREF} onClick={onClickButton}>
        Simulation personnalisée
      </S.Button>
    </S.Card>
  )
})

BlocErrorMain.propTypes = {
  flag: PropTypes.oneOf(ERROR_TYPES).isRequired,
  onClickButton: PropTypes.func.isRequired,
}

BlocErrorMain.displayName = 'BlocErrorMain'
